import { styled } from '@mui/material/styles';

const calced = (s, em = '0.2') => `calc(${s}% - ${em}em)`;

export const HalfCircleWrap = styled('div')(({ theme }) => ({
  width: '1em',
  height: '1em',
  fontSize: '1.5rem',
  flexShrink: '0',
  userSelect: 'none',
  position: 'relative',
  lineHeight: 1.5,

  '& .halfFill': {
    position: 'absolute',
    backgroundColor: theme.palette.text.primary,
    borderRadius: '1em 0 0 1em',
    height: calced(100),
    width: calced(52, '0.1'),
    margin: '0.2em 0 0 0.1em',
  },
}));
